/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import Dialog from "@mui/material/Dialog";
import React, { ReactNode } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import dialogModalStyle from "./dialogModalStyle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Close from "@mui/icons-material/Close";
import { DialogProps } from "@mui/material/Dialog/Dialog";
import { IconButton, Theme } from "@mui/material";

type DialogModalProps = {
  open: boolean;
  onClose?: () => void;
  actions?: ReactNode;
  responsive?: boolean;
  title: string;
  children: ReactNode;
} & DialogProps;

const DialogModal = ({ open, onClose, title, children, actions, responsive = false, ...rest }: DialogModalProps) => {
  const fullScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Dialog
      sx={dialogModalStyle.dialogModal}
      open={open}
      onClose={onClose}
      fullScreen={responsive && fullScreen}
      PaperProps={{
        style: {
          padding: "1rem 0",
        },
      }}
      {...rest}
    >
      <DialogTitle sx={dialogModalStyle.dialogModalTitle}>
        {title}
        {!!onClose && (
          <IconButton onClick={onClose} sx={dialogModalStyle.closeIcon}>
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={dialogModalStyle.dialogModalContent}>{children}</DialogContent>
      {!!actions && <DialogActions sx={dialogModalStyle.dialogModalActions}>{actions}</DialogActions>}
    </Dialog>
  );
};

export default DialogModal;
